import React from 'react';

export default function FinanciallySoundYesAlert() {
  return (
    <div className="financial-sound-yes-alert vads-u-padding-y--2 vads-u-padding-x--2">
      <p className="vads-u-margin-y--0">
        First time applicants are required to submit 24 months of financial data
        to determine financial soundness. To confirm your institution’s
        financial soundness, you will be required to submit supporting financial
        documentation as part of this application. U.S. Department of Education,
        Title IV school participants are not required to provide financial
        statements with the application.
      </p>
    </div>
  );
}
